import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useRevealStyles } from '../hooks/useRevealStyles';

/**
 * Weidner override of Aster's PropertyOverview. The parent clamps the home
 * page description behind a Read More toggle; here the blurb always renders
 * in full.
 */
export function PropertyOverview() {
  useRevealStyles();
  const headingRef = useScrollReveal<HTMLDivElement>();

  return (
    <section className="pt-4 md:pt-6 pb-2 md:pb-3 bg-[var(--vibe-color-background)]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div ref={headingRef} className="reveal-fade-up">
          <RichTextContent
            path="propertyoverview.pre_title"
            as="p"
            className="overview-nav-font text-sm sm:text-base text-[var(--vibe-color-text)] mb-8 tracking-wide uppercase"
          />

          <RichTextContent
            path="propertyoverview.description"
            as="div"
            className="overview-description-nav-font text-sm sm:text-base text-[var(--vibe-color-text)] max-w-3xl mx-auto leading-relaxed [&_a]:text-primary [&_a]:underline"
          />
        </div>
      </div>

      <style>{`
        /* Match the header navigation typeface (body token, loaded globally by
           the Header). The font-family inherits to the rich-text children, so
           the text renders in the same face as the nav links. */
        .overview-description-nav-font,
        .overview-description-nav-font *,
        .overview-nav-font,
        .overview-nav-font * {
          font-family: var(--vibe-font-body);
        }
      `}</style>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'PropertyOverview',
  displayName: 'Property Overview',
  tokens: {
    'propertyoverview.pre_title': {
      label: 'Subtitle',
      type: 'richtext',
      defaultField: 'property_home_romance_title',
      defaultValue: 'Life at our community is like nowhere else',
    },
    'propertyoverview.description': {
      label: 'Description',
      type: 'richtext',
      defaultField: 'property_long_description',
      defaultValue: '<p>Discover the perfect blend of comfort, style, and convenience at our community.</p>',
    },
  },
};

(PropertyOverview as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default PropertyOverview;
